import BaseModel from "lib/model";

export default BaseModel.extend({
    idAttribute: "id",
    url: function () {
        if (this.isNew()) {
            return `/api/v3.0/catalog/${this.collection.parent.id}/links`;
        }
        return `/api/v3.0/catalog/${this.collection.parent.id}/link/${this.id}`;
    },
    props: {
        id: "objectId",
        link: { type: "string", required: true },
        label: { type: "string", required: false },
    },
});
